import React from 'react'

// Sending emails
import emailjs from 'emailjs-com'
import styled from 'styled-components'
import { AiOutlineLinkedin, AiOutlineInstagram } from 'react-icons/ai'
import { VscGithub } from 'react-icons/vsc'
import { IconContext } from 'react-icons'

// Toast
import toast from 'react-hot-toast'

// Animations
import { useScroll } from './useScroll'
import { Fade } from './Animation'
import { motion } from 'framer-motion'

export default function ContactUs() {
    function sendEmail(e) {
        e.preventDefault()

        // Defining service and transporter as gmail
        const emailPromise = emailjs.sendForm(
            'service_n2i1dvd',
            'template_7uqnyjp',
            e.target,
            'user_A6lGAvNeNFr5K7pfJ39bY',
        )

        toast.promise(emailPromise, {
            loading: 'Sending email...',
            success: 'Email sent successfully!',
            error: 'Error in sending email!',
        })

        emailPromise.then(
            (result) => {
                console.log('Sent mail')
            },
            (error) => {
                console.log(error)
                alert('Error in sending Email!')
            },
        )

        e.target.reset()
    }

    const [element, controls] = useScroll()

    return (
        <ContactContainer
            ref={element}
            variants={Fade}
            initial="hidden"
            animate={controls}
        >
            <h1 className="text-center mb-4">Contact Me </h1>
            <form className="contact-form" onSubmit={sendEmail}>
                <Top>
                    <input
                        type="text"
                        required
                        placeholder="Your Name (required)"
                        name="name"
                    />
                    <input
                        type="email"
                        required
                        placeholder="Your Email (required)"
                        name="email"
                    />
                </Top>
                <Bottom>
                    <input
                        type="text"
                        placeholder="Your Message"
                        name="message"
                    />
                </Bottom>
                <ButtonWrapper>
                    <button>Get in touch</button>
                </ButtonWrapper>
                <div className="query">
                    <h5>
                        Any queries? Post them here and I will respond within
                        24hrs.
                    </h5>
                </div>
            </form>
            <Footer>
                <div className="imagecontainer">
                    <IconContext.Provider
                        value={{ color: 'white', size: '40px' }}
                    >
                        <div
                            style={{
                                padding: '1rem 0.7rem',
                                cursor: 'pointer',
                            }}
                        >
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.linkedin.com/in/chirag-rao-691317197/"
                            >
                                <AiOutlineLinkedin className="icon" />
                            </a>
                        </div>
                    </IconContext.Provider>
                    <IconContext.Provider
                        value={{ color: 'white', size: '40px' }}
                    >
                        <div
                            style={{
                                padding: '1rem 0.7rem',
                                cursor: 'pointer',
                            }}
                        >
                            <a
                                href="https://www.instagram.com/spaceface0072/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <AiOutlineInstagram className="icon" />
                            </a>
                        </div>
                    </IconContext.Provider>
                    <IconContext.Provider
                        value={{ color: 'white', size: '40px' }}
                    >
                        <div
                            style={{
                                padding: '1rem 0.7rem',
                                cursor: 'pointer',
                            }}
                        >
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://github.com/SpaceFace02"
                            >
                                <VscGithub className="icon" />
                            </a>
                        </div>
                    </IconContext.Provider>
                </div>
            </Footer>
        </ContactContainer>
    )
}

const ContactContainer = styled(motion.div)`
    h1 {
        text-align: center;
        margin: 5rem 0rem;
        font-size: 4rem;
        font-weight: lighter;
        color: white;
    }

    form input {
        background: transparent;
        border: none;
        outline: none;
        border-bottom: 1px solid #23d997;
        padding: 0.9rem 0rem;

        caret-color: #23d997;
        color: white;
    }
    .query {
        text-align: center;
        padding: 3rem 0rem 1rem 0rem;
        h5 {
            font-weight: lighter;
            font-size: 1rem;
        }
        button {
            border: none;
        }
    }
`

const Top = styled.div`
    padding: 3rem 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
        margin: 0rem 1.1rem;
        width: 600px;
        font-size: 2rem;
        border: none;
    }
    @media screen and (max-width: 520px) {
        flex-direction: column;
        input {
            width: 100%;
        }
    }
`
const Bottom = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0rem 3rem;
    input {
        width: 1250px;
        font-size: 2rem;
    }
    @media screen and (max-width: 520px) {
        flex-direction: column;
        input {
            width: 100%;
        }
    }
`

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const Footer = styled.div`
    .imagecontainer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon {
        &:hover {
            background-color: #23d997;
        }
    }
`
